"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralize = void 0;
function pluralize(word, num) {
    return num === 1 ? word : "".concat(word, "s");
}
exports.pluralize = pluralize;
